<template>
    <div class="EvieChatMessageError">
        <p class="EvieChatMessageError__text">
            {{ errorText }}
        </p>

        <NewButton
            class="EvieChatMessageError__retry"
            variant="outline"
            color="secondary"
            size="sm"
            type="button"
            @click="$emit('retry')"
        >
            Retry
        </NewButton>
    </div>
</template>

<style lang="scss">
.EvieChatMessageError {
    display: flex;
    flex-direction: column;
    gap: 8px;
    font-size: 14px;

    &__text {
        margin: 0;
    }

    &__retry,
    &__cta {
        align-self: flex-start;
    }
}
</style>

<script lang="ts">
    import { defineComponent, PropType } from 'vue';

    import { ChatMessageErrorType } from '@evidentid/tprm-portal-lib/models/evie/ChatMessageErrorType.model';

    import NewButton from '@/components/new-button/NewButton.vue';
    import { EvieThreadMessage } from '@/modules/evie-ai/models/EvieThreadMessage.model';

    const ERROR_MESSAGES: Record<ChatMessageErrorType, string> = {
        [ChatMessageErrorType.PERMISSION_DENIED]: 'You don\'t have permission for this action.',
        [ChatMessageErrorType.RATE_LIMIT]: 'Too many requests. Please wait a moment and try again.',
        [ChatMessageErrorType.UNAVAILABLE]: 'Evie is temporarily unavailable. Please try again shortly.',
        [ChatMessageErrorType.NETWORK]: 'Something went wrong. Please check your connection and try again.',
        [ChatMessageErrorType.CONTEXT_LIMIT]:
            'This conversation has reached its limit. Start a new chat to continue.',
    };

    export default defineComponent({
        name: 'EvieChatMessageError',
        components: { NewButton },
        props: {
            message: { type: Object as PropType<EvieThreadMessage>, required: true },
        },
        emits: [ 'retry' ],
        computed: {
            errorType(): ChatMessageErrorType {
                return this.message.errorType ?? ChatMessageErrorType.NETWORK;
            },
            errorText(): string {
                // ERROR_MESSAGES has per-error-type copy ready for when BE returns structured error codes.
                void ERROR_MESSAGES;
                return 'Something went wrong. Try again.';
            },
        },
    });
</script>
